import Lenis from 'lenis'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Scroller {
  constructor () {
    const lenis = new Lenis()
    window.lenis = lenis

    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add(time => {
      lenis.raf(time * 1000)
    })
    gsap.ticker.lagSmoothing(0)
  }
}

export default Scroller
